import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a wall sconce mounted at 1.7 m against the z=0 wall plane,
// facing +Z: a small backplate, a short arm and an up-facing shade cup with a
// glow-tone top disc. Authored at true mounting height (the viewer re-seats
// the base on its pedestal; a builder keeps the authored height).
const BLACK = "#2e2e30";
const BRASS = "#c9a35a";
const GLOW = "#f5e9c8";

const MOUNT_Y = 1.7;

export const sconceLight = defineModel({
  id: "sconce-light",
  batchId: "modern",
  name: "Sconce light",
  tags: ["modern", "interior", "fixture", "lighting", "wall"],
  summary: "A wall sconce with an up-facing brass shade cup.",
  description:
    "Wall-mounted at 1.7 m against the z=0 plane, facing +Z. Place against " +
    "any wall piece of the Modern Living kit.",
  tiles: { w: 1, h: 1 },
  footprint: 0.6,
  parts(): Part[] {
    return [
      // Backplate against the wall.
      { geometry: new THREE.BoxGeometry(0.12, 0.18, 0.03), color: BLACK,
        position: [0, MOUNT_Y, 0.015] },
      // Short arm reaching out from the plate.
      { geometry: new THREE.BoxGeometry(0.03, 0.03, 0.12), color: BLACK,
        position: [0, MOUNT_Y, 0.09] },
      // Up-facing shade cup (flares upward).
      { geometry: new THREE.CylinderGeometry(0.09, 0.05, 0.13, 12), color: BRASS,
        position: [0, MOUNT_Y + 0.07, 0.15] },
      // Glow-tone top disc.
      { geometry: new THREE.CylinderGeometry(0.075, 0.075, 0.02, 12), color: GLOW,
        position: [0, MOUNT_Y + 0.14, 0.15] },
    ];
  },
  animations: [],
});
